import { render, staticRenderFns } from "./FacturarDialogCategory.vue?vue&type=template&id=1606ad8e&scoped=true"
import script from "./FacturarDialogCategory.vue?vue&type=script&lang=js"
export * from "./FacturarDialogCategory.vue?vue&type=script&lang=js"
import style0 from "./FacturarDialogCategory.vue?vue&type=style&index=0&id=1606ad8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1606ad8e",
  null
  
)

export default component.exports